import * as React from "react";
import styled from "styled-components";
import { useLightboxContext } from "../context";
const _LightboxFrame = ({ children, ...props }) => {
    useLightboxContext("LightboxFrame");
    return (React.createElement("div", { "data-testid": "frame", ...props, onClick: (e) => e.stopPropagation() }, children));
};
export const LightboxFrame = styled(_LightboxFrame) ``;
//# sourceMappingURL=LightboxFrame.js.map